<template>
  <div v-if="ncstraining" class="mx-auto">
    <mdb-row class="my-2">
      <mdb-col md="2" class="text-right bolder">훈련 기관</mdb-col>
      <mdb-col md="9">{{ncstraining.org.name}}</mdb-col>
    </mdb-row>
    <mdb-row class="my-2">
      <mdb-col md="2" class="text-right bolder">기준 년도</mdb-col>
      <mdb-col md="9"><input class="input-underline" v-model="ncstraining.baseYear"/></mdb-col>
    </mdb-row>
    <mdb-row class="my-2">
      <mdb-col md="2" class="text-right bolder">NCS 분야</mdb-col>
      <mdb-col md="9"><input class="input-underline" v-model="ncstraining.baseTraining"/></mdb-col>
    </mdb-row>
    <mdb-row class="my-2">
      <mdb-col md="2" class="text-right bolder">NCS 직종</mdb-col>
      <mdb-col md="9"><input class="input-underline w-50" v-model="ncstraining.code"/></mdb-col>
    </mdb-row>
    <mdb-row class="my-2">
      <mdb-col md="2" class="text-right bolder">NCS 훈련명</mdb-col>
      <mdb-col md="9"><input class="input-underline w-100" v-model="ncstraining.name"/></mdb-col>
    </mdb-row>
    <mdb-row class="my-2">
      <mdb-col md="2" class="text-right bolder">설명</mdb-col>
      <mdb-col md="9"><mdb-input type="textarea" class="m-0" :rows="4" v-model="ncstraining.description"/></mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
export default {
  name: 'StaffNcsTrainingIntro',
  props: ['ncstraining'],
  data: () => ({
    TAG: 'StaffNcsTrainingIntro.vue'
  }),
  methods: {
  }
}
</script>
